import { useEffect } from 'react';
import { useComponentDidMount } from './use-component-did-mount';
export const useComponentDidUpdate = (callback, deps) => {
    const isComponentMounted = useComponentDidMount();
    useEffect(() => {
        if (isComponentMounted) {
            callback();
        }
    }, deps);
};
